import React from 'react';
import { Segment, Table, Header, Icon, Popup } from 'semantic-ui-react';
import { IconHeader } from '../util/css';

/**
    props: switchToTable (function), lease (Object)
*/

export default class LeasesDetail extends React.Component {
    getLeaseholderName(el) {
        if (el.entityType.id === 1) {
            return (el.physicalEntity.firstName + ' ' + el.physicalEntity.lastName + ' - ' + el.entityType.name);
        } else if (el.entityType.id === 2) {
            return (el.legalEntity.name + ' - ' + el.entityType.name);
        }
        return (el.organizationalUnitLeaseholder.name + ' - ' + el.entityType.name);
    }

    render() {
        const { lease } = this.props;
        return (
            <div>
                <Header as="h1">Zakupi</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            O zakupu
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={this.props.switchToTable} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table celled>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Organizaciona jedinica - imovina</b></Table.Cell>
                                    <Table.Cell textAlign="center">{lease.organizationalUnitProperty.organizationalUnit.name} - {lease.organizationalUnitProperty.property.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Početak zakupa</b></Table.Cell>
                                    <Table.Cell textAlign="center">{!!lease.beginDate && lease.beginDate.getUTCDate() + 1}. {!!lease.beginDate && lease.beginDate.getUTCMonth() + 1}. {!!lease.beginDate && lease.beginDate.getUTCFullYear()}.</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Istek zakupa</b></Table.Cell>
                                    <Table.Cell textAlign="center">{!!lease.endDate && lease.endDate.getUTCDate()}. {!!lease.endDate && lease.endDate.getUTCMonth() + 1}. {!!lease.endDate && lease.endDate.getUTCFullYear()}.</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Mjesečni prihodi (BAM)</b></Table.Cell>
                                    <Table.Cell textAlign="center">{lease.incomePerMonth}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Zakupac - Tip zakupca</b></Table.Cell>
                                    <Table.Cell textAlign="center">{this.getLeaseholderName(lease.leaseholder)}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Namjena zakupa</b></Table.Cell>
                                    <Table.Cell textAlign="center">{lease.purpose}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Napomena</b></Table.Cell>
                                    <Table.Cell textAlign="center">{lease.comment}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>

                        {lease.legalDocument ?
                            <React.Fragment>
                                <Header as="h3">Pravni dokument</Header>
                                <Table celled>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell textAlign="center"><b>Tip pravnog dokumenta</b></Table.Cell>
                                            <Table.Cell textAlign="center">{lease.legalDocument.legalDocumentType.name}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign="center"><b>Datum izdavanja pravnog dokumenta</b></Table.Cell>
                                            <Table.Cell textAlign="center">{!!lease.legalDocument.date && (new Date(lease.legalDocument.date)).getUTCDate()}. {!!lease.legalDocument.date && (new Date(lease.legalDocument.date)).getUTCMonth() + 1}. {!!lease.legalDocument.date && (new Date(lease.legalDocument.date)).getUTCFullYear()}.</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign="center"><b>Broj pravnog dokumenta</b></Table.Cell>
                                            <Table.Cell textAlign="center">{lease.legalDocument.documentNumber}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign="center"><b>Napomena</b></Table.Cell>
                                            <Table.Cell textAlign="center">{lease.legalDocument.comment}</Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </React.Fragment> :
                            <Header as="h3">Ovaj zakup nema pravni dokument</Header>
                        }
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leases/LeasesDetails.js